const keys = [
  'storyLocalSignIn', 'storyFriendsSignIn', 'storyNoFollowing', 'storyCountryUnset',
  'storySearchParticipants', 'storySearchEmpty', 'storyFilteredOpinionsEmpty', 'storyFilteredStatisticsEmpty',
];

const copy = {
  en: [
    'Sign in to see local opinions.',
    'Sign in to see opinions from people you follow.',
    'You are not following anyone yet.',
    'Set your country in account settings to see local opinions.',
    'Name or username',
    'No matching opinions found.',
    'No public opinions in this group yet.',
    'No opinions in this group yet.',
  ],
  ru: [
    'Войдите, чтобы видеть мнения людей из вашей страны.',
    'Войдите, чтобы видеть мнения людей, на которых вы подписаны.',
    'Вы ни на кого не подписаны.',
    'Укажите страну в настройках аккаунта, чтобы видеть мнения людей из вашей страны.',
    'Имя, фамилия или @ник',
    'Подходящие мнения не найдены.',
    'В этой группе пока нет публичных мнений.',
    'В этой группе пока нет мнений.',
  ],
  es: [
    'Inicia sesión para ver las opiniones locales.',
    'Inicia sesión para ver las opiniones de las personas que sigues.',
    'Todavía no sigues a nadie.',
    'Indica tu país en los ajustes de la cuenta para ver las opiniones locales.',
    'Nombre o usuario',
    'No se encontraron opiniones coincidentes.',
    'Aún no hay opiniones públicas en este grupo.',
    'Aún no hay opiniones en este grupo.',
  ],
  fr: [
    'Connectez-vous pour voir les avis des personnes de votre pays.',
    'Connectez-vous pour voir les avis des personnes que vous suivez.',
    'Vous ne suivez encore personne.',
    'Indiquez votre pays dans les paramètres du compte pour voir les avis des personnes qui y vivent.',
    'Nom ou pseudonyme',
    'Aucun avis correspondant trouvé.',
    'Ce groupe n’a pas encore d’avis publics.',
    'Ce groupe n’a pas encore d’avis.',
  ],
  de: [
    'Melde dich an, um lokale Meinungen zu sehen.',
    'Melde dich an, um Meinungen von Personen zu sehen, denen du folgst.',
    'Du folgst noch niemandem.',
    'Gib dein Land in den Kontoeinstellungen an, um lokale Meinungen zu sehen.',
    'Name oder Benutzername',
    'Keine passenden Meinungen gefunden.',
    'In dieser Gruppe gibt es noch keine öffentlichen Meinungen.',
    'In dieser Gruppe gibt es noch keine Meinungen.',
  ],
  it: [
    'Accedi per vedere le opinioni locali.',
    'Accedi per vedere le opinioni delle persone che segui.',
    'Non segui ancora nessuno.',
    'Imposta il tuo paese nelle impostazioni dell’account per vedere le opinioni locali.',
    'Nome o nome utente',
    'Nessuna opinione corrispondente trovata.',
    'Questo gruppo non ha ancora opinioni pubbliche.',
    'Questo gruppo non ha ancora opinioni.',
  ],
  pt: [
    'Entre para ver as opiniões locais.',
    'Entre para ver as opiniões das pessoas que você segue.',
    'Você ainda não segue ninguém.',
    'Defina seu país nas configurações da conta para ver as opiniões locais.',
    'Nome ou nome de usuário',
    'Nenhuma opinião correspondente encontrada.',
    'Ainda não há opiniões públicas neste grupo.',
    'Ainda não há opiniões neste grupo.',
  ],
  tr: [
    'Yerel görüşleri görmek için giriş yapın.',
    'Takip ettiğiniz kişilerin görüşlerini görmek için giriş yapın.',
    'Henüz kimseyi takip etmiyorsunuz.',
    'Yerel görüşleri görmek için hesap ayarlarından ülkenizi seçin.',
    'Ad veya kullanıcı adı',
    'Eşleşen görüş bulunamadı.',
    'Bu grupta henüz herkese açık görüş yok.',
    'Bu grupta henüz görüş yok.',
  ],
  ja: [
    '地域の意見を見るにはログインしてください。',
    'フォローしている人の意見を見るにはログインしてください。',
    'まだ誰もフォローしていません。',
    '地域の意見を見るにはアカウント設定で国を設定してください。',
    '名前またはユーザー名',
    '一致する意見が見つかりませんでした。',
    'このグループにはまだ公開された意見がありません。',
    'このグループにはまだ意見がありません。',
  ],
  ko: [
    '지역 의견을 보려면 로그인해 주세요.',
    '팔로우하는 사람들의 의견을 보려면 로그인해 주세요.',
    '아직 아무도 팔로우하지 않았습니다.',
    '지역 의견을 보려면 계정 설정에서 국가를 지정해 주세요.',
    '이름 또는 사용자 이름',
    '일치하는 의견을 찾을 수 없습니다.',
    '이 그룹에는 아직 공개된 의견이 없습니다.',
    '이 그룹에는 아직 의견이 없습니다.',
  ],
  zh: [
    '请登录以查看本地观点。',
    '请登录以查看你关注的人的观点。',
    '你还没有关注任何人。',
    '请在账号设置中选择国家，以查看本地观点。',
    '姓名或用户名',
    '未找到匹配的观点。',
    '此群组暂无公开观点。',
    '此群组暂无观点。',
  ],
  hi: [
    'स्थानीय राय देखने के लिए साइन इन करें।',
    'जिन लोगों को आप फ़ॉलो करते हैं उनकी राय देखने के लिए साइन इन करें।',
    'आप अभी किसी को फ़ॉलो नहीं करते हैं।',
    'स्थानीय राय देखने के लिए खाता सेटिंग में अपना देश चुनें।',
    'नाम या उपयोगकर्ता नाम',
    'कोई मेल खाती राय नहीं मिली।',
    'इस समूह में अभी कोई सार्वजनिक राय नहीं है।',
    'इस समूह में अभी कोई राय नहीं है।',
  ],
};

export default Object.fromEntries(Object.entries(copy).map(([language, values]) => [
  language, Object.fromEntries(keys.map((key, index) => [key, values[index]])),
]));
